<template>
  <v-form ref="formSigner" v-model="valid" :lazy-validation="lazy">
    <v-row no-gutters>
      <v-col>
        <h2>Nuevo firmante</h2>
        <v-divider class="mb-4"></v-divider>
      </v-col>
    </v-row>
    <v-row >
      <v-col xs="12" md="4">
        <v-text-field
            id="signer_form__nombres__text"
            name="signer_form__nombres__text"
            v-model="signer.nombres"
            :counter="80"
            maxlength="80"
            :error-messages="getErrors('signer.nombres', 'Los nombres')"
            label="Nombres"
            required
            @input="$v.signer.nombres.$touch()"
            @blur="$v.signer.nombres.$touch()"
        ></v-text-field>
      </v-col>
      <v-col xs="12" md="4">
        <v-text-field
            id="signer_form__apellido_paterno__text"
            name="signer_form__apellido_paterno__text"
            v-model="signer.paterno"
            :counter="50"
            maxlength="50"
            :error-messages="getErrors('signer.paterno', 'El apellido paterno')"
            label="Apellido Paterno"
            required
            @input="$v.signer.paterno.$touch()"
            @blur="$v.signer.paterno.$touch()"
        ></v-text-field>
      </v-col>
      <v-col xs="12" md="4">
        <v-text-field
            id="signer_form__apellido_materno__text"
            name="signer_form__apellido_materno__text"
            v-model="signer.materno"
            :counter="50"
            maxlength="50"
            :error-messages="getErrors('signer.materno', 'El apellido materno')"
            label="Apellido Materno"
            @input="$v.signer.materno.$touch()"
            @blur="$v.signer.materno.$touch()"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs="12" md="8">
        <v-text-field
            id="signer_form__email__text"
            name="signer_form__email__text"
            v-model="signer.email"
            :counter="120"
            maxlength="120"
            :error-messages="getErrors('signer.email', 'El Email')"
            label="Email"
            required
            @input="$v.signer.email.$touch()"
            @blur="$v.signer.email.$touch()"
        ></v-text-field>
      </v-col>
      <v-col xs="12" md="4">
        <v-text-field
            id="signer_form__rfc__text"
            name="signer_form__rfc__text"
            v-model="signer.rfc"
            :counter="13"
            maxlength="13"
            :error-messages="getErrors('signer.rfc', 'El RFC')"
            label="RFC"
            required
            @input="$v.signer.rfc.$touch()"
            @blur="$v.signer.rfc.$touch()"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-spacer></v-spacer>
      <v-col xs="4" md="4">
        <v-btn color="error" id="signer_form__cancelar__button" text @click="hideForm">Cancelar</v-btn>
        <v-btn class="ml-2" id="signer_form__agregar__button" color="success" 
        :disabled="this.$v.$invalid"
               @click="submit">Agregar</v-btn
        >
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import VuelidateHelper from '@/utils/VuelidateHelper'
import { maxLength, required } from 'vuelidate/lib/validators'
import { notSpecialChars, rfcValidation, rfcDuplicate, rfcNotOwner, capitalize, emailValidation, emailDuplicate, emailNotOwner } from '@/utils/VuelidateCustoms'
import Signer from '@/models/Signer'
import { signersStoreActions, signersStoreData } from '@/modules/signers/store/signersStoreHelpers'
import { userData } from '@/store/helpers'

export default {
  name: 'SignerForm',
  data() {
    return {
      vuelidateHelper: null,
      valid: false,
      lazy: false,
      signer: new Signer()
    }
  },
  created() {
    this.vuelidateHelper = new VuelidateHelper(this.$v)
  },
  computed: {
    ...signersStoreData,
    ...userData
  },
  watch: {
    'signer.nombres': function(text){
      this.signer.nombres = capitalize(text, true)
    },
    'signer.paterno': function(text){
      this.signer.paterno = capitalize(text, true)
    },
    'signer.materno': function(text){
      this.signer.materno = capitalize(text, true)
    },
    'signer.rfc': function(text){
      this.signer.rfc = text.toUpperCase()
    }
  },
  methods: {
    ...signersStoreActions,
    getErrors(campo, label = '') {
      return this.vuelidateHelper.getErrors(campo, label)
    },
    hideForm() {
      this.hideAddSigner()
      this.signer = new Signer()
      this.$refs.formSigner.reset()
      this.$v.$reset()
    },
    submit() {
      if (this.$refs.formSigner.validate()) {
        if (!this.$v.$invalid) {
          this.addSigner(this.signer)
          this.hideForm()
        }
      }
    }
  },
  validations() {
    return {
      signer: {
        nombres: { required, maxLength: maxLength(80), notSpecialChars },
        paterno: { required, maxLength: maxLength(50), notSpecialChars },
        materno: { maxLength: maxLength(50), notSpecialChars },
        email: { required, maxLength: maxLength(120), emailValidation, emailDuplicate: emailDuplicate({signers: this.signers}), emailNotOwner: emailNotOwner({owner: this.accountData}) },
        rfc: { required, maxLength: maxLength(13), rfcValidation, rfcDuplicate: rfcDuplicate({signers: this.signers}), rfcNotOwner: rfcNotOwner({owner: this.accountData}) }
      }
    }
  }
}
</script>
